import { graphql } from 'react-relay/legacy';

export const userGeoInfoQuery = graphql`
    query userGeoInfoQuery(
        $userId: String = ""
        $cookieDomain: String = ""
        $eligibleAbTest: String = ""
    ) {
        viewer {
            regionalInfo(
                userId: $userId
                cookieDomain: $cookieDomain
                eligibleAbTest: $eligibleAbTest
            ) {
                countryCode
                zipCode
                regionsByZipCode {
                    displayName
                    urlLabel
                }
                incomeLevel {
                    incomeBracket
                    incomePercentile
                }
            }
        }
    }
`;
